import script from "./AutoSwitchTabList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoSwitchTabList.vue?vue&type=script&lang=ts&setup=true"

import "./AutoSwitchTabList.vue?vue&type=style&index=0&id=9fe9b5d6&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fe9b5d6"]])

export default __exports__